import * as types from "../types";

const initState ={
    IndigoFFNNo:"",
    //indigoffnreTry:false
    indigoFFNCallStatus:false
    //indigoffncall:false,
}

const IndigoFFNReducer = (state = initState, action) => {
    switch (action.type) {
        case types.SAVE_INDIGO_FFN_DATA:
        return {
            ...state,
            IndigoFFNNo: action.payload
        };
        case types.INDIGO_FETCH_FFN_CALL_STATUS:
        return {
            ...state,
                indigoFFNCallStatus: action.value
        };
        default:
        return state;
    }
}

export default IndigoFFNReducer;
